// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input_Fps0m","focus":"Input_focus_1CVwB"};